<template>
  <div class="container py-5" v-if="prof">

    <div class="row mb-4">
      <div class="col-md-3 text-center">
         <img
          v-if="prof.user?.urlImage"
          :src="getImageUrl(prof.user.urlImage)"
          alt="Photo disciple"
          class="detail-photo"
        />

        <img
          v-else
          :src="defaultPhoto"
          alt="Photo par défaut"
          class="detail-photo"
        />
      </div>

      <div class="col-md-9">
        <h2>{{ prof.nom }} {{ prof.prenom }}</h2>

        <p v-if="prof.qualification">
          <strong>Qualification :</strong> {{ prof.qualification.libelle }}
        </p>

        <p><strong>Nationalité :</strong> {{ prof.nationalite }}</p>
        <p><strong>Email :</strong> {{ prof.email }}</p>
        <p><strong>Téléphone :</strong> {{ prof.telProfesseur1 }}</p>
        <p><strong>Années d'expérience :</strong> {{ prof.anneeExperience }}</p>
      </div>
    </div>

    <hr />

    <h4>Biographie</h4>
    <p>{{ prof.biographie }}</p>

    <hr />

    <!-- MATIÈRES ENSEIGNÉES -->
    <h4>Matières enseignées</h4>

    <ul class="matiere-list">
      <li v-for="matiere in prof.matieres" :key="matiere.id">
        {{ matiere.libelle }}
      </li>
    </ul>

    <!-- ACTIVITÉS (optionnel) -->
    <div v-if="prof.activites?.length">
      <hr />
      <h4>Activités</h4>
      <ul>
        <li v-for="act in prof.activites" :key="act.id">
          {{ act.libelle }}
        </li>
      </ul>
    </div>

  </div>
</template>
<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import ApiService from "@/services/ApiService";

export default defineComponent({
  name: "ProfesseurDetail",

  setup() {
    const route = useRoute();
    const prof = ref<any>(null);
    const defaultPhoto = "/21.jpg";

    const getProfesseur = async () => {
      try {
        const response = await ApiService.get(`/professeurs/${route.params.id}`);
        prof.value = response.data.data;
        console.log("tttt",prof.value)
      } catch (error) {
        console.error(error);
      }
    };
    function getImageUrl(filename?: string) : string {
          if (!filename) return ''
          return `${ApiService.vueInstance.axios.defaults.baseURL?.split("api")[0]}uploads/Users/${filename}`; }
        onMounted(getProfesseur);

    return {
      prof,
      defaultPhoto,
      getImageUrl
    };
  },
});
</script>
<style>
    
.detail-photo {
  width: 180px;
  height: 180px;
  border-radius: 50%;
  border: 4px solid #ffc107;
  object-fit: cover;
}

.matiere-list li {
  list-style: disc;
  margin-left: 20px;
}
</style>

